import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";

export function useQueryParams() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const removeQueryParams = useCallback(
    (keys: string[]): void => {
      const urlSearchParams = new URLSearchParams(searchParams.toString());
      keys.forEach((key) => urlSearchParams.delete(key));
      const params = urlSearchParams.toString();
      router.push(`${pathname}${params ? `?${params}` : ""}`, { scroll: false });
    },
    [pathname, router, searchParams]
  );

  return {
    getQueryParam: useCallback(
      (key: string): string | null => searchParams.get(key),
      [searchParams]
    ),
    setQueryParam: useCallback(
      (key: string, value: string): void => {
        const urlSearchParams = new URLSearchParams(searchParams.toString());
        urlSearchParams.set(key, value);
        const params = urlSearchParams.toString();
        router.push(`${pathname}${params ? `?${params}` : ""}`, { scroll: false });
      },
      [pathname, router, searchParams]
    ),
    removeQueryParam: useCallback(
      (key: string): void => removeQueryParams([key]),
      [removeQueryParams]
    ),
    removeQueryParams,
  };
}
